export default [
  {
    path: '/login',
    name: 'login',
    meta: { title: 'Login - Innovation Law Lab Platform' },
    component: () => import('@/views/Login'),
  },
]
